export const endpoints = {
  createProduct: () => '/dashboard/products',
  productDetail: productId => `/dashboard/products/${productId}`,
  productVariants: () => `/dashboard/products/variants`,
  productSearch: () => `/dashboard/products/search`,
  categoryList: () => '/dashboard/merchants/categories',
  productTagList: () => '/dashboard/products/tags'
};
